import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGooglephotosComponent } from './simple-icons-googlephotos.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGooglephotosComponent ],
    exports:      [ SimpleIconsGooglephotosComponent ],
    bootstrap:    []
})
export class SimpleIconsGooglephotosModule {}
